import { mapGetters, mapActions } from 'vuex'
import EmployeeboardModule, { MODULE_NAME } from './index'

const EmployeeboardMixin = {
  namespaced: EmployeeboardModule.namespaced,
  computed: { ...mapGetters(MODULE_NAME, Object.keys(EmployeeboardModule.getters)) },
  methods: { ...mapActions(MODULE_NAME, Object.keys(EmployeeboardModule.actions)) }
}

export default EmployeeboardMixin



// WEBPACK FOOTER //
// ./src/store/module/employeeboard/mixin.js